function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import { browserHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Link from "./Link";

var Nav = function (_React$Component) {
  _inherits(Nav, _React$Component);

  function Nav() {
    _classCallCheck(this, Nav);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.render = function render() {
    var _props = this.props,
        nav = _props.nav,
        onNavClick = _props.onNavClick,
        children = _props.children;
    return React.createElement("div", {
      className: "cms--nav"
    }, React.createElement("div", {
      className: "cms--menu-links"
    }, nav && nav.map(function (n) {
      return React.createElement(Link, {
        key: n.uri,
        to: n.menu_uri,
        onClick: function onClick() {
          return onNavClick && onNavClick();
        }
      }, n.title);
    })), children);
  };

  return Nav;
}(React.Component);

Nav.propTypes = process.env.NODE_ENV !== "production" ? {
  nav: PropTypes.array,
  onNavClick: PropTypes.func,
  children: PropTypes.element
} : {};
export default Nav;